export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.adf7424f.png";